/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Display_Horizontal_Padding_LabelInputs */



/**
* | output |
* | --- |
* | "Horizontal Padding (%)" |
*
* @param {Options_Display_Horizontal_Padding_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_display_horizontal_padding_label = /** @type {((inputs?: Options_Display_Horizontal_Padding_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Display_Horizontal_Padding_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Marge horizontale (%)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Horizontale Polsterung (%)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Riempimento orizzontale (%)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Горизонтальный отступ (%)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Relleno horizontal (%)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("水平填充率 (%)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("水平パディング（％）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्षैतिज पैडिंग (%)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Preenchimento horizontal (%)")
	return /** @type {LocalizedString} */ ("Horizontal Padding (%)")
});